import { createSlice } from "@reduxjs/toolkit";

export const logs = createSlice({
  name: "logs",
  initialState: {
    signalR: [],
  },
  reducers: {
    addSignalR: (state, action) => {
      const newData = [
        { arguments: action.payload, time: new Date().toISOString() },
        ...state.signalR,
      ];
      newData.slice(0, 200);
      state.signalR = newData;
    },
  },
});
